import { VideoCredits } from '../../../../redux/api/fymAPI.types';

/**
 * The credits that the workspace can still spend: the plan credits left this month plus the pack
 * credits (`totalLeft` of the credits answer). Null when the plan has no limit, or while the
 * credits load: then the client does not know, and the server decides.
 */
export function videoCreditsLeft(credits: VideoCredits | null | undefined): number | null {
  if (credits === null || credits === undefined || typeof credits.limit !== 'number') {
    return null;
  }
  const left = Math.max(0, credits.limit - credits.used) + Math.max(0, credits.packBalance);
  // A broken answer (no number) knows nothing: the server decides.
  return Number.isFinite(left) ? left : null;
}

/**
 * True only when the balance (plan plus packs) is really below the cost. A cost of 0 (images), an
 * unknown balance or a plan with no limit is never short, so the app never says "not enough
 * credits" when it does not know.
 */
export function isShortOfVideoCredits(credits: VideoCredits | null | undefined, cost: number): boolean {
  if (cost <= 0) {
    return false;
  }
  const left = videoCreditsLeft(credits);
  return left !== null && cost > left;
}
